/**
 * Forgot Password Page for trAInedup.ai
 * Provides interface to send password reset email
 */

import React from 'react';
import { Layout } from '../components/common/Layout';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';
import { SEOHead } from '../components/seo/SEOHead';

/**
 * Forgot password page component
 */
export const ForgotPasswordPage: React.FC = () => {
  return (
    <Layout showFooter={false}>
      <SEOHead
        title="Reset Password - trAInedup.ai"
        description="Reset your trAInedup.ai account password."
        noindex={true}
      />
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          <ForgotPasswordForm />
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPasswordPage;
